// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__awQK9","active":"Pagination_active__coFl4","navButton":"Pagination_navButton__yB90a"};